const Backbone = require('backbone');
const SmsProductView = require('app/views/store/pages/sms/show.page.js');
var SocialBarView = Backbone.View.extend({
	el: '.js-social-bar',

	events: {
		'click .js-social-link': '_handleSocialClick',
		'click .js-sms-product': '_handleSmsProduct'
	},

	initialize: function() {
		var self = this;
		if (window.dataLayer.page === 'product:display') {
			import('views/store/common/social/social_email_modal').then((SocialEmailModalView) => {
				self.socialModalView = new SocialEmailModalView();
			});
		}
	},

	_handleSocialClick: function(e) {
		e.preventDefault();

		const socialId = e.currentTarget.id;
		const socialName = socialId && socialId.indexOf('-') !== -1 ? socialId.split('-')[1] : socialId;
		let socialUrl = $(e.currentTarget).data('link');

		// Fire tracking
		this._socialFireOmniture(socialName);

		if (socialName === 'print') {
			window.print();
		} else {
			if (socialName === 'pinterest') {
				socialUrl = this._getFavoritesPagePinUrl(socialUrl);
			}

			if (socialUrl) {
				if (window.BCOM.device.isMobile) {
					window.location.assign(socialUrl);
				} else {
					this._openSocialWindow(socialName, socialUrl);
				}
			}
		}
	},

	_socialFireOmniture: function(socialName) {
		var data = {
			trackingString: `${window.dataLayer.pageName}~${socialName}`
		};
		Backbone.trigger('omniture:socialshare', data, window.dataLayer.pageName, socialName);
	},

	_openSocialWindow: function(name, url) {
		var params = 'width=680,height=480';
		window.open(url, name, params);
	},

	_handleSmsProduct: function() {
		this.childViews.smsProductView = new SmsProductView();
	},

	/**
	 * If pinit button (not on product page) we need to update the 'media' param with first favorites list image
	 * @return {string}
	 */
	_getFavoritesPagePinUrl: function(pinUrl) {
		var imageUrl = window.dataLayer.model ? window.dataLayer.model.firstImage : '';
		return imageUrl ? window.BCOM.util.updateURLParameters(pinUrl, 'media', imageUrl) : pinUrl;
	}
});

module.exports = SocialBarView;
